@if (jobs.isLoading() && !jobs.hasValue()) {
  <div class="seg-vacio" role="status">
    <mat-icon>hourglass_empty</mat-icon>
    <p>Buscando los encendidos y apagados…</p>
  </div>
} @else if (jobs.error()) {
  <div class="seg-vacio seg-vacio--error" role="alert">
    <mat-icon>error_outline</mat-icon>
    <p>No se pudieron traer los encendidos y apagados.</p>
  </div>
} @else {
  <div
    class="seg-kpis"
    role="list"
    aria-label="Resumen de encendidos y apagados"
  >
    @for (k of kpis(); track k.etiqueta) {
      <div class="seg-kpis__item" role="listitem" [matTooltip]="k.ayuda">
        <app-stat-card
          [title]="k.etiqueta"
          [value]="k.valor"
          [icon]="k.icono"
          [color]="k.color"
          [formatAsNumber]="true"
        ></app-stat-card>
      </div>
    }
  </div>

  <div class="seg-barra">
    <p class="seg-pista">
      <mat-icon>info</mat-icon>
      <span>
        Los que se mandaron a mano, a una luminaria o a un grupo, puesta o zona.
      </span>
    </p>
    <div class="seg-crece"></div>
    @if (puedeVerHijos) {
      <mat-slide-toggle
        color="primary"
        [checked]="hijos()"
        (change)="cambiarHijos($event.checked)"
        matTooltip="Suma lo de los clientes hijos y muestra de qué cliente es cada encendido o apagado."
      >
        Datos de mis clientes
      </mat-slide-toggle>
    }
    <button
      irxBoton="secundario"
      type="button"
      (click)="recargar()"
      [disabled]="jobs.isLoading()"
    >
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
  </div>

  @if (!enCurso().length && !terminadas().length) {
    <div class="seg-calma">
      <mat-icon>task_alt</mat-icon>
      <span>
        No hay encendidos ni apagados en la ventana. Aparecen en cuanto se
        enciende o apaga una luminaria o un grupo.
      </span>
    </div>
  }

  @if (enCurso().length) {
    <h2 class="seg-seccion">
      En curso
      <span class="seg-seccion__cuenta">{{ enCurso().length | number }}</span>
    </h2>
    <div class="seg-fichas">
      @for (f of enCurso(); track f.c.id) {
        <ng-container
          *ngTemplateOutlet="ficha; context: { $implicit: f }"
        ></ng-container>
      }
    </div>
  }

  @if (terminadas().length) {
    <h2 class="seg-seccion">
      Terminados
      <span class="seg-seccion__cuenta">
        {{ terminadas().length | number }}
      </span>
    </h2>
    <div class="seg-fichas">
      @for (f of terminadas(); track f.c.id) {
        <ng-container
          *ngTemplateOutlet="ficha; context: { $implicit: f }"
        ></ng-container>
      }
    </div>
  }

  <p class="seg-pista seg-pista--pie">
    <mat-icon>info</mat-icon>
    <span>
      Se arman con los
      <strong>últimos {{ ventana | number }} envíos</strong>
      de encendido y apagado: uno más viejo que eso deja de aparecer.
    </span>
  </p>
}

<ng-template #ficha let-f>
  <a
    class="irx-enlace seg-ficha"
    [style.--tono]="f.tono"
    [routerLink]="['/main/luminarias/seguimiento/encendidos', f.c.id]"
    [queryParams]="{ hijos: hijos() ? null : '0' }"
  >
    <span class="seg-ficha__icono">
      <mat-icon>{{ f.icono }}</mat-icon>
    </span>

    <div class="seg-ficha__cuerpo">
      <div class="seg-ficha__titulo">
        <h3>{{ f.titulo }}</h3>
        <span class="seg-chip" [style.--tono]="f.tono">
          <mat-icon>{{ f.iconoEstado }}</mat-icon>
          {{ f.estado }}
        </span>
      </div>
      <p class="seg-ficha__objetivo">
        {{ f.objetivo }}
        @if (hijos() && f.cliente) {
          ·
          <span [matTooltip]="f.jerarquia">{{ f.cliente }}</span>
        }
      </p>

      <div
        class="seg-barra-avance"
        role="img"
        [attr.aria-label]="f.porcentaje + ' por ciento aplicado'"
      >
        @for (s of SEGMENTOS; track s.clave) {
          @if (f.d[s.clave]) {
            <span
              [style.width.%]="ancho(f, s.clave)"
              [style.background]="s.tono"
            ></span>
          }
        }
      </div>

      <ul class="seg-leyenda">
        @for (s of SEGMENTOS; track s.clave) {
          @if (f.d[s.clave]) {
            <li [matTooltip]="s.ayuda">
              <span class="seg-punto" [style.background]="s.tono"></span>
              <strong>{{ f.d[s.clave] | number }}</strong>
              {{ s.etiqueta }}
            </li>
          }
        }
      </ul>
    </div>

    <div class="seg-ficha__cifras">
      <span
        class="seg-porcentaje"
        matTooltip="Sobre las luminarias que confirmaron el comando."
      >
        {{ f.porcentaje }}
        <small>%</small>
      </span>
      <span class="seg-fecha">{{ fecha(f.c.inicio) }}</span>
      <span class="seg-hace">{{ cuando(f.c.inicio) }}</span>
      @if (f.falta) {
        <span
          class="seg-falta"
          matTooltip="Regla de tres sobre el ritmo que lleva. No es una promesa: si las que faltan son las que no comunican, no cierra."
        >
          faltarían {{ f.falta }}
        </span>
      }
    </div>

    <mat-icon class="seg-ficha__ir">chevron_right</mat-icon>
  </a>
</ng-template>
